<ul class="nav nav-tabs" role="tablist">
  <ng-container *ngFor="let item of items; count as count">
    <li *ngIf="count > 1 || !collapse" [ngClass]="{ 'nav-item': true, 'active': item.active }">
      <button [id]="item.id + '-link'" [ngClass]="{ 'nav-link': true, 'active': item.active }" (click)="onTabClick(item)" style="cursor: pointer" role="tab">{{ item.label }}</button>
    </li>
  </ng-container>
</ul>
<div class="tab-content">
  <slot #itemSlot (slotchange)="onSlottedContentChanged()"></slot>
</div>
